'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteGlobalButtonBox', [function () {
      return {
        templateUrl: 'views/directives/notes/saNoteGlobalButtonBox.html',
        restrict: 'A',
        scope: {
          me: '=',
          org: '='
        },
        link: function(scope) {
          scope.state = {
            overlayOpen: false,
            q: {
              overlayOpen: function() { return scope.state.overlayOpen; }
            }
          };
        }
      };
    }]);
